function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Ifav = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "33",
    height: "28",
    viewBox: "0 0 33 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.3137 2.59947C28.6381 0.931758 26.4197 0.0202556 24.0521 0.0202556C21.6845 0.0202556 19.4594 0.93851 17.7837 2.60622L16.9086 3.47721L16.0199 2.59272C14.3443 0.925006 12.1124 0 9.74475 0C7.38394 0 5.1588 0.918254 3.48995 2.57921C1.81431 4.24693 0.891691 6.46154 0.898475 8.81794C0.898475 11.1743 1.82788 13.3822 3.50351 15.0499L16.2438 27.7299C16.4202 27.9055 16.6576 28 16.8883 28C17.1189 28 17.3564 27.9122 17.5327 27.7367L30.3001 15.0769C31.9758 13.4092 32.8984 11.1946 32.8984 8.8382C32.9052 6.48179 31.9893 4.26718 30.3137 2.59947Z",
    fill: "black"
  }));
});